import { createAction, props } from '@ngrx/store';

export const setMenuState = createAction(
  '[UIState] Set Menu state',
  props<{
    menuState: any; // add model
  }>(),
);

export const clearMenuState = createAction('[UIState] Clear Menu state');

export const setAppRestricted = createAction(
  '[UIState] Set App Restricted State',
  props<{
    restricted: boolean;
  }>(),
);

export const setLocationPermissions = createAction(
  '[UIState] Set Location Permissions',
  props<{
    location_allowed: boolean;
  }>(),
);

export const setSoftCheckState = createAction(
  '[UIState] Set Soft check state',
  props<{
    us_state: string;
  }>(),
);

export const forceWalletLogout = createAction('[UIState] Force Wallet Logout');
